import { ACTIVE_ASSETS } from 'constants/assets/activeAssets'
import React from 'react'
import styled from 'styled-components'
import { AssetBox } from './AssetBox/AssetBox'

export const TopAssets = (props) => {
  return (
    <TopAssetsContainer>
      <Title>Top Assets</Title>
      <AssetBoxContainer>
        <AssetBoxTrack>
          {ACTIVE_ASSETS.map((coin, index) => {
            return <AssetBox key={index} coin={coin} />
          })}
        </AssetBoxTrack>
      </AssetBoxContainer>
    </TopAssetsContainer>
  )
}

const TopAssetsContainer = styled.div`
  width: 90%;
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
`

const AssetBoxContainer = styled.div`
  min-height: 127px;
`
const AssetBoxTrack = styled.div`
  position: absolute;
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  overflow-x: auto;
  min-height: 127px;
`

const Title = styled.h1`
  font-size: 1.1rem;
  font-weight: 300;
  text-transform: uppercase;
  width: 100%;
  padding: 5px 30px 10px 0;
`
